import { useGetSrpResultsQuery } from '@/src/api/rtkQuery/srpFlightResults'
import { getSelectedCurrency } from '@/src/redux/slices/currencySlice'
import { useAppSelector } from '@/src/redux/store'
import { getConversionRateDetails, getCurrencyByLocale } from '@/src/utils/currency/formatCurrency'
import { isEmpty } from '@/src/utils/generalUtils'
import { useCallback, useMemo } from 'react'
import useGetSearchQueryURL from '../../srp/getSearchQueryURL'
import useFormatCurrency from '../useFormatCurrency'

const useFormatCurrencyForSrp = () => {
    const toCurrency = useAppSelector(getSelectedCurrency)
    const { currency: fromCurrency } = getCurrencyByLocale()
    const { formatCurrency } = useFormatCurrency()
    const { query, error: pastDateError } = useGetSearchQueryURL()
    const { data } = useGetSrpResultsQuery(
        { query },
        {
            skip: !query || !!pastDateError
        }
    )

    const formatCurrencyForSrp = useCallback(
        (price: number, usePrecision: boolean = true) => {
            const { jsons } = data || {}
            const { currencyList = [] } = jsons || {}
            const conversionRateDetails = isEmpty(currencyList)
                ? { rate: 1, buffer: 0 }
                : getConversionRateDetails(currencyList, fromCurrency, toCurrency)
            const { rate = 1, buffer = 0 } = conversionRateDetails || {}

            return formatCurrency({
                toCurrency,
                rate,
                buffer,
                price,
                usePrecision
            })
        },
        [formatCurrency, toCurrency, data]
    )

    // Memoize the format function to prevent unnecessary re-renders
    const memoizedFormatCurrency = useMemo(
        () => ({
            formatCurrency: formatCurrencyForSrp
        }),
        [formatCurrencyForSrp]
    )

    return memoizedFormatCurrency
}

export default useFormatCurrencyForSrp
